export enum ItemTypeEnum {
    SewingTrim = 'SewingTrim',
    PackingTrim = 'PackingTrim',
    Fabric = 'Fabric'
  }
